export default __webpack_public_path__ + "static/media/visa.3a8eaf1d.svg";